// extracted by css-extract-rspack-plugin
export default {"header":"header--ySj2vOmCxI82rHPS"};